// novita.js — le novità e le correzioni da mostrare all'apertura del programma.
//
// PERCHÉ
// Chi usa il gestionale ogni giorno non ha modo di sapere cosa è cambiato: se un risultato si
// comporta in modo diverso, o se c'è una pagina nuova, se ne accorge per caso. Qui si tiene
// l'elenco, in italiano e senza paroloni, di quello che è stato **aggiunto** (implementazioni) e di
// quello che è stato **corretto** (errata corrige). All'apertura il programma mostra solo le voci
// più recenti di quelle già viste da quella persona (la data "vista" sta nel browser).
//
// COME SI AGGIORNA
// Si aggiunge una voce in cima a `NOVITA` con la data del giorno (formato AAAA-MM-GG, così
// l'ordinamento è automatico). `tipo` può essere 'implementazione' o 'correzione'.

export const NOVITA = [
  {
    data: '2026-10-08',
    tipo: 'implementazione',
    titolo: 'Form contatti del sito e registrazioni protette dagli abusi',
    testo: "Il modulo contatti del sito vetrina e la registrazione di un nuovo club non accettano più richieste in serie: oltre 5 messaggi in un'ora dallo stesso indirizzo (o 3 in 24 ore dallo stesso indirizzo email) la richiesta viene rifiutata e il modulo lo dice. Serve a evitare che qualcuno usi il modulo del tuo sito per far partire email a raffica a nome del club. Stesso controllo sulle email di conferma dell'iscrizione al centro estivo: al massimo 4 invii per iscrizione (una famiglia ne fa due, genitore e società).",
  },
  {
    data: '2026-10-07',
    tipo: 'implementazione',
    titolo: 'Autocertificazione per genitore singolo',
    testo: "Fra i moduli da stampare (Stampe & PDF, scegliendo un atleta) c'è la nuova autocertificazione per il genitore che esercita da solo la responsabilità genitoriale: decesso dell'altro genitore o intervento in via di urgenza (autotutela).",
  },
  {
    data: '2026-10-07',
    tipo: 'correzione',
    titolo: 'Campionati a gironi con il tipo sbagliato',
    testo: "Il campionato Under 18 del Club Sportivo era stato creato come \"Esterno\": il programma segnava tutte le partite in trasferta. Corretto, e adesso quando si crea o si modifica un campionato a gironi il programma avvisa se il tipo non è \"Campionato\".",
  },
  {
    data: '2026-10-07',
    tipo: 'correzione',
    titolo: 'Convocazioni: tornano gli atleti "fuori età"',
    testo: "Sotto la rosa della squadra non comparivano più gli atleti della categoria inferiore da promuovere. La ricerca della categoria sotto ora funziona per tutte le squadre, non solo per quelle chiamate esattamente \"Under 14\", \"Juniores\" e simili.",
  },
  {
    data: '2026-10-07',
    tipo: 'implementazione',
    titolo: 'Ogni risultato dice da dove viene',
    testo: "Nel database ogni dato scritto dai bollettini federali porta con sé il riferimento del comunicato e della pagina (es. \"CU-FI-16 del 30/09/2026, pag. 24\"). Se un dato viene corretto a mano dall'app, risulta come \"manuale\".",
  },
  {
    data: '2026-10-05',
    tipo: 'implementazione',
    titolo: 'Il giro dei bollettini gira da solo sul server',
    testo: "Risultati, \"dove si gioca\" e sanzioni si aggiornano da soli dal bollettino federale: martedì–sabato alle 20:00 e mercoledì–sabato alle 08:30. Non serve più lanciare niente a mano, e i campionati mancanti si caricano da soli (le partite nuove).",
  },
  {
    data: '2026-10-04',
    tipo: 'implementazione',
    titolo: '"Cose da fare" all\'apertura',
    testo: "La prima pagina dopo l'accesso: distinte da preparare, quote non incassate, atleti senza documento. Si apre subito su quello che c'è in sospeso, invece di doverlo cercare.",
  },
  {
    data: '2026-10-04',
    tipo: 'correzione',
    titolo: 'Sincronizzare il calendario non azzera più i risultati',
    testo: "Aggiornando il calendario di un torneo, il programma scriveva \"vuoto\" sui risultati già inseriti (un 3-3 è stato cancellato così). Adesso il calendario e i risultati sono separati.",
  },
  {
    data: '2026-10-04',
    tipo: 'correzione',
    titolo: 'Giornate di squalifica sbagliate',
    testo: "Quando in una pagina del bollettino c'erano più provvedimenti, il programma leggeva il contesto di tutta la pagina e assegnava a tutti le stesse giornate. Adesso il contesto si legge riga per riga.",
  },
  {
    data: '2026-10-04',
    tipo: 'implementazione',
    titolo: 'Dove si gioca nella distinta',
    testo: "Nella distinta di gara compare impianto, città e indirizzo: in casa il nostro campo, in trasferta quello dell'avversario, presi dal calendario federale. Prima il campo di casa finiva anche nelle partite in trasferta.",
  },
]

/** La data della novità più recente (stringa AAAA-MM-GG), o null se l'elenco è vuoto. */
export const dataUltimaNovita = (elenco = NOVITA) =>
  (elenco || []).reduce((massima, n) => (!massima || n.data > massima ? n.data : massima), null)

/**
 * Le novità da mostrare a chi le ha viste l'ultima volta alla data `visto`.
 * Data vuota = non ha mai visto niente: si mostrano solo quelle dell'ultimo giorno presente,
 * così un dipendente nuovo non si trova davanti mesi di cronaca.
 */
export const novitaDaMostrare = (visto, elenco = NOVITA) => {
  const tutte = elenco || []
  if (!visto) {
    const ultima = dataUltimaNovita(tutte)
    return tutte.filter((n) => n.data === ultima)
  }
  return tutte.filter((n) => n.data > visto)
}

/** Le novità divise fra correzioni e implementazioni (per mostrarle in due elenchi). */
export const dividiNovita = (elenco) => ({
  correzioni: (elenco || []).filter((n) => n.tipo === 'correzione'),
  implementazioni: (elenco || []).filter((n) => n.tipo === 'implementazione'),
})

/** Chi vede l'avviso all'apertura: chi gestisce la società, non atleti e genitori. */
export const RUOLI_CHE_VEDONO_LE_NOVITA = ['admin', 'dirigente', 'segreteria', 'allenatore', 'superadmin']
